import { render, staticRenderFns } from "./DateRangeCustomPluginBiz.vue?vue&type=template&id=2b896f02&scoped=true"
import script from "./DateRangeCustomPluginBiz.vue?vue&type=script&lang=js"
export * from "./DateRangeCustomPluginBiz.vue?vue&type=script&lang=js"
import style0 from "./DateRangeCustomPluginBiz.vue?vue&type=style&index=0&id=2b896f02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b896f02",
  null
  
)

export default component.exports